import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { SponsorshipPage } from './pages/SponsorshipPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-11">
      <Routes data-id="element-12">
        <Route path="/" element={<App data-id="element-14" />} data-id="element-13" />
        <Route path="/sponsorship" element={<SponsorshipPage data-id="element-16" />} data-id="element-15" />
      </Routes>
    </BrowserRouter>;
}